export interface CallerLocation {
  file?: string;
  line?: number;
  column?: number;
  functionName?: string;
}

export const getCallerLocation = (
  depth: number = 3,
  errorOverride?: Error,
): CallerLocation => {
  if (
    typeof process === 'undefined' ||
    typeof process.versions === 'undefined' ||
    typeof process.versions.node === 'undefined'
  ) {
    return {};
  }

  const err = errorOverride ?? new Error();
  const stackLine = err.stack?.split('\n')[depth]?.trim();

  if (!stackLine) return {};

  const match = stackLine.match(/at\s+(?:(.*?)\s+\()?(.+?):(\d+):(\d+)\)?$/);
  if (!match) return {};

  const [, functionName, file, line, column] = match;
  return {
    functionName,
    file,
    line: Number(line),
    column: Number(column),
  };
};
